<template>
  <section class="latest-news">
    <div class="page-width">
      <div class="section-heading">
        <h2>最新动态</h2>
        <router-link to="/information">查看全部 ›</router-link>
      </div>

      <div v-if="featuredNews" class="news-grid">
        <a :href="getNewsHref(featuredNews)" :target="opensInNewTab(featuredNews) ? '_blank' : null" :rel="opensInNewTab(featuredNews) ? 'noopener noreferrer' : null" class="featured-card">
          <div class="featured-image">
            <img :src="featuredNews.coverImg" :alt="featuredNews.title" @error="useFallbackCover($event, 0)" />
          </div>
          <div class="featured-content">
            <h3>{{ featuredNews.title }}</h3>
            <p>{{ getExcerpt(featuredNews) }}</p>
            <time>{{ formatPublishTime(featuredNews.publishTime) }}</time>
          </div>
        </a>

        <div class="side-news">
          <a
            v-for="(item, index) in sideNews"
            :key="item.id || item.title"
            :href="getNewsHref(item)"
            :target="opensInNewTab(item) ? '_blank' : null"
            :rel="opensInNewTab(item) ? 'noopener noreferrer' : null"
            class="side-card"
          >
            <div class="side-image">
              <img :src="item.coverImg" :alt="item.title" @error="useFallbackCover($event, index + 1)" />
            </div>
            <div class="side-content">
              <h3>{{ item.title }}</h3>
              <p>{{ getExcerpt(item) }}</p>
              <time>{{ formatPublishTime(item.publishTime) }}</time>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* global _api */
// import LocalNews from "../../information/components/local_news";

export default {
  name: "HomeNews",
  data() {
    return {
      newsList: [],
      fallbackCovers: [
        require("@/assets/images/new-img/a012_2.jpeg"),
        require("@/assets/images/new-img/new0309/a0309_1.png"),
        require("@/assets/images/new-img/a011_10.png")
      ]
    };
  },
  computed: {
    featuredNews() {
      return this.newsList[0];
    },
    sideNews() {
      return this.newsList.slice(1);
    }
  },
  created() {
    this.requestNewsList();
  },
  methods: {
    useFallbackCover(event, index) {
      const image = event.target;
      image.onerror = null;
      image.src = this.fallbackCovers[index % this.fallbackCovers.length];
    },
    getExcerpt(item) {
      return item.summary || item.content || "";
    },
    getNewsHref(item) {
      if (Number(item.jumpExternal) === 1 && item.hyperUrl) return item.hyperUrl;
      if (item.externalUrl) return item.externalUrl;
      return item.id ? "/news/detail/" + item.id : "#";
    },
    opensInNewTab(item) {
      return (Number(item.jumpExternal) === 1 && !!item.hyperUrl) || !!item.externalUrl;
    },
    formatPublishTime(value) {
      if (value === null || value === undefined || value === "") return "";

      const timestamp = typeof value === "string" && /^\d+$/.test(value) ? Number(value) : value;
      const date = new Date(typeof timestamp === "number" && timestamp < 100000000000 ? timestamp * 1000 : timestamp);
      if (isNaN(date.getTime())) return "";

      return date.getFullYear() + "." + String(date.getMonth() + 1).padStart(2, "0") + "." + String(date.getDate()).padStart(2, "0");
    },
    requestNewsList() {
      _api.all
        .getHomePageNews()
        .then(res => {
          if (res.code === 200 && res.data && res.data.length) {
            this.newsList = res.data;
          }
        })
        .catch(() => { this.newsList = []; });
    }
  }
};
</script>

<style lang="scss" scoped>
.latest-news {
  padding: 0 20px 80px;
  background: #f7f8f9;
}

.page-width {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}

.section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 21px;
}

.section-heading h2 {
  margin: 0;
  color: #17202a;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.035em;
  line-height: 40px;
}

.section-heading a {
  display: inline-flex;
  height: 34px;
  box-sizing: border-box;
  padding: 0 14px;
  align-items: center;
  border: 1px solid #cfd3d6;
  border-radius: 4px;
  color: #26303a;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-decoration: none;
}

.news-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.featured-card,
.side-card {
  display: block;
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  color: #17202a;
  text-decoration: none;
}

.featured-card { grid-column: span 2; }

.featured-image,
.side-image {
  position: relative;
  overflow: hidden;
}

.featured-image,
.side-image { height: 300px; }

img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.featured-card:hover img,
.side-card:hover img {
  transform: scale(1.04);
}

.featured-content,
.side-content {
  display: flex;
  height: 186px;
  padding: 20px;
  flex-direction: column;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
}

h3 {
  margin: 0 0 8px;
  color: #111925;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
}

.side-news {
  display: contents;
}

.side-card { min-height: 0; }

.featured-content p,
.side-content p { display:-webkit-box;overflow:hidden;margin:0 0 14px;color:#777f8a;font-size:16px;line-height:24px;-webkit-box-orient:vertical;-webkit-line-clamp:2; }
.featured-content time,
.side-content time { margin-top:auto;color:#9ca4ad;font-size:13px;line-height:22px; }

@media (min-width:1081px) {
  .latest-news { padding-right:20px;padding-left:20px; }
  .news-grid { gap:20px; }
  .featured-card,.side-card { height:486px;align-self:start; }
}

@media (min-width: 721px) {
  .section-heading h2 { position: relative; top: 3px; }
}

@media (max-width: 1080px) {
  .latest-news { padding-right: 28px; padding-left: 28px; }
  .news-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .featured-image, .side-image { height: clamp(210px, 31vw, 300px); }
}

@media (max-width: 720px) {
  .latest-news { padding-right: 20px; padding-left: 20px; }
  .section-heading { margin-bottom: 18px; align-items: flex-end; gap: 18px; }
  .section-heading h2 { font-size: 28px; }
  .news-grid { grid-template-columns: 1fr; }
  .featured-card { grid-column: auto; }
  .featured-image, .side-image { height: auto; aspect-ratio: 16 / 10; }
  .featured-content, .side-content { height: auto;min-height: 0; padding: 20px; }
}

@media (max-width: 560px) {
  .latest-news { padding-right: 18px; padding-left: 18px; }
  .featured-content, .side-content { min-height: 0; }
}
</style>
